import React, { useEffect, useState, MouseEvent } from 'react';
import Layout from '../../components/global/layout';
import EditProfile from '../../components/Profile/Edit';
import ChangePassword from '../../components/Profile/ChangePassword';
import GroupSettings from '../../components/Profile/GroupSettings';
import ApiClient from '../../methods/api/apiClient';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import environment from '../../environment';

const Settings: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const [tabs, setTabs] = useState<string>('profile');
  const [form, setForm] = useState<any>();
  const { tab, id: editingUserId } = useParams<{ tab?: string; id?: string }>();

  const isGroupLeader = environment.groupLeaderRoleIds.includes(
    user?.customerRole?._id || user?.customerRole
  );
  // console.log('DEBUG Settings:', {
  //   customerRole: user?.customerRole,
  //   customerRoleId: user?.customerRole?._id,
  //   groupLeaderRoleIds: environment.groupLeaderRoleIds,
  //   isGroupLeader
  // });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const value = {
      rescheduleTime: form?.rescheduleTime,
      id: form?.id
    };
    ApiClient.put('setting', value).then(res => {
      if (res.success) {
        // success
      }
    });
  };

  const handleTabClick =
    (tabName: string) =>
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      setTabs(tabName);
    };

    // cw: prevent loading in Settings page
    const [groupData, setGroupData] = useState(null);

    useEffect(() => {
      if (isGroupLeader && user?.groupId) {
        const groupId = user?.groupId?._id || user?.groupId;
        ApiClient.get('api/group/detail', { id: groupId }).then(res => {
          if (res.success) setGroupData(res.data);
        });
      }
    }, [isGroupLeader, user]);

    useEffect(() => {
      if (editingUserId) {
        setTabs('profile');
      } else if (tab === 'edit') {
        setTabs('profile');
      } else if (tab === 'change-password') {
        // The menu links to /profile/change-password, but the internal tab key is 'change-pass'.
        // Normalize so the Change Password form renders instead of a blank page.
        setTabs('change-pass');
      } else {
        setTabs(tab || 'profile');
      }
    }, [tab, editingUserId]);

  return (
    <Layout>
      {!tab && !editingUserId && (
        <div>
          <h3 className="mb-3">Settings</h3>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                className={tabs === 'profile' ? 'nav-link active' : 'nav-link'}
                href="#"
                onClick={handleTabClick('profile')}
              >
                Edit Profile
              </a>
            </li>

            <li className="nav-item">
              <a
                className={tabs === 'change-pass' ? 'nav-link active' : 'nav-link'}
                href="#"
                onClick={handleTabClick('change-pass')}
              >
                Change Password
              </a>
            </li>

            {isGroupLeader && (
              <li className="nav-item">
                <a
                  className={
                    tabs === 'group-settings'
                      ? 'nav-link active'
                      : 'nav-link'
                  }
                  href="#"
                  onClick={handleTabClick('group-settings')}
                >
                  Group Settings
                </a>
              </li>
            )}
          </ul>
        </div>
      )}

      <div>
        {tabs === 'profile' && <EditProfile />}
        {tabs === 'change-pass' && <ChangePassword />}
        {tabs === 'group-settings' && isGroupLeader && <GroupSettings initialData={groupData} />}
      </div>
    </Layout>
  );
};

export default Settings;
